namespace $ {
	
	const { rem, px } = $mol_style_unit
	
	$mol_style_define( $shm_hitalama_textbook_text_header, {
		
		border: {
			radius: $mol_gap.round,
		},
		
		margin: {
			left: rem( -.5 ),
			right: rem( -.5 ),
		},
		
		padding: {
			left: rem( .5 ),
			right: rem( .5 ),
		},
		
		'@': {
			shm_hitalama_textbook_text_header_current: {
				'true': {
					background: {
						color: $mol_theme.hover,
					},
					box: {
						shadow: [
							{
								inset: true,
								x: px( 3 ),
								y: 0,
								blur: 0,
								spread: 0,
								color: $mol_theme.current,
							},
						],
					},
				},
			},
		},
		
	} )
	
}
